export const RandomInteger = (min: number = 1, max: number = 999999999): number => {
  return Math.floor(Math.random() * (max - min + 1)) + min;
};
